import React, { useContext, useCallback, useState, useMemo } from 'react';
import { LocalizationContext } from 'app/localization/Context';
import { CurrentPageContext } from 'app/home/general-components/HistoryStackContext';
import CustomIconBack from 'app/home/home-components/CustomIconBack';

import { ReactComponent as IconCopy } from 'images/general/copy.svg';
import { ReactComponent as IconTickBlue } from 'images/general/tick-blue.svg';
import IconLogo1 from 'images/siri/main-log/logo.png';
import IconLogo2 from 'images/siri/main-log/logo@2x.png';
import IconLogo3 from 'images/siri/main-log/logo@3x.png';
import IconShortcutsLogo1 from 'images/siri/shortcuts-app/logo.png';
import IconShortcutsLogo2 from 'images/siri/shortcuts-app/logo@2x.png';
import IconShortcutsLogo3 from 'images/siri/shortcuts-app/logo@3x.png';

import packageJson from '../../../../../../package.json';

import "./SiriScenario.scss"

const runScenarioShortcutLink = {
    staging: "https://www.icloud.com/shortcuts/0740fe40e08047bf8a1d6ca2eb3b855f",
    production: "https://www.icloud.com/shortcuts/2614d5b562694ff9b50a559103ea3536",
    // TODO: add production-co
}

export function SiriRunScenario({ gateway, home }) {
    const l = useContext(LocalizationContext);
    const s = l.strings;
    const si = s.siriScenario;

    const p = useContext(CurrentPageContext);
    const dismissHandler = p.dismiss;

    const scenarioId = p.state.scenarioId;
    const scenario = useMemo(() => {
        return gateway.scenarios.find(({ id }) => id === scenarioId);
    }, [scenarioId, gateway.scenarios]);
    const scenarioName = scenario.name;
    const soloScenarioAuthToken = gateway.soloScenarioAuthToken;

    const [copied, setCopied] = useState(false);

    const accessKey = useMemo(() => {
        if ((soloScenarioAuthToken !== undefined) && (home.isSolo)) {
            return window.btoa(JSON.stringify({
                a: soloScenarioAuthToken,
                h: home.home_id,
                s: String(scenarioId)
            }))
        } else {
            return "";
        }
    }, [soloScenarioAuthToken, home.home_id, home.isSolo, scenarioId]);

    const isCopyAvailable =
        (navigator !== undefined) &&
        (navigator.clipboard !== undefined) &&
        (navigator.clipboard.writeText !== undefined) &&
        (accessKey.length > 0);

    const copyToClipboard = useCallback(() => {
        navigator.clipboard.writeText(accessKey).then(function () {
            console.log("clipboard successfully set");
            setCopied(true);
        }, function () {
            console.log("clipboard write failed");
        });
    }, [accessKey]);

    const isStaging = (packageJson.serverName === "staging");

    const openShortcut = useCallback(() => {
        window.open(
            isStaging ? runScenarioShortcutLink.staging : runScenarioShortcutLink.production,
            '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
    }, [isStaging]);

    return (
        <div className="siri-run-scenario-page">
            <div className="bg-blank" />
            <div className="bg-secondary-color" />
            <div className="siri-run-scenario-page-content">
                <CustomIconBack className="nav-icon" /> <div className="nav-button" onClick={dismissHandler} />

                <img src={IconLogo1}
                    srcSet={`${IconLogo2} 2x, ${IconLogo3} 3x`}
                    className="siri-icon" alt="" />
                <div className="title">{si.titleFunc(scenarioName)}</div>

                <div className="section">
                    <div className="num">{l.localizeNumber(1) + "."}</div>
                    <div className="contents">
                        <div className="text">{si.section1Text}</div>
                        {/* <textarea className="textarea" rows="1" readOnly={true} value={accessKey}></textarea> */}
                        <div className="textarea-container">
                            <textarea className="textarea" readOnly={true} value={accessKey}></textarea>
                        </div>
                        {isCopyAvailable ? <div className="button-border" onClick={copyToClipboard}>
                            <IconCopy className="icon" />
                            <div className="label">{si.section1Button}</div>

                            {
                                copied ? <div className="outer-label">
                                    <div className="label">{si.copied}</div>
                                    <IconTickBlue className="icon" />
                                </div> : null
                            }
                        </div> : null}
                    </div>
                </div>

                <div className="section">
                    <div className="num">{l.localizeNumber(2) + "."}</div>
                    <div className="contents">
                        <div className="text">{si.section2Text}</div>
                        <div className="button-border" onClick={openShortcut}>
                            <img src={IconShortcutsLogo1}
                                srcSet={`${IconShortcutsLogo2} 2x, ${IconShortcutsLogo3} 3x`}
                                className="icon" alt="" />
                            <div className="label">{si.section2Button}</div>
                        </div>
                    </div>
                </div>

                <div className="section">
                    <div className="num">{l.localizeNumber(3) + "."}</div>
                    <div className="contents">
                        <div className="text">{si.section3Text}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}